module.exports = __webpack_public_path__ + "static/Pricing-603910cf74b6686620a64e89f4f12c8b.png";